import React from "react";
import { Box, Typography } from "@material-ui/core";

const SistemaInativo = ({ message }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    minHeight="100vh"
    bgcolor="#0f172a"
    color="#e2e8f0"
    padding={4}
  >
    <Box textAlign="center" maxWidth={520}>
      <Typography variant="h4" gutterBottom>
        Sistema Indisponível
      </Typography>
      <Typography style={{ color: "#94a3b8", lineHeight: 1.6 }}>
        {message ||
          "Sistema temporariamente indisponível. Entre em contato com o suporte."}
      </Typography>
    </Box>
  </Box>
);

export default SistemaInativo;
